import { Link } from "react-router-dom";
import { getPopular } from "@/lib/catalog";

export default function PopularRanking() {
  const list = getPopular(6);

  return (
    <aside className="reveal bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 h-fit">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
          <i className="ri-fire-line text-lg"></i>
        </span>
        <div>
          <h2 className="font-heading font-bold text-lg text-foreground-950">热门排行</h2>
          <p className="text-xs text-foreground-500">本周最受关注的电影</p>
        </div>
      </div>
      <ol className="space-y-1">
        {list.map((m, i) => (
          <li key={m.id}>
            <Link
              to={`/detail/${m.id}`}
              className="flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <span
                className={`w-6 text-center font-heading font-bold text-lg shrink-0 ${
                  i === 0 ? "text-primary-500" : i < 3 ? "text-accent-500" : "text-foreground-300"
                }`}
              >
                {i + 1}
              </span>
              <div className="w-12 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img src={m.cover} alt={m.title} title={`${m.title} - 电影详情`} className="w-full h-full object-cover object-top" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {m.title}
                </p>
                <p className="text-xs text-foreground-500 truncate mt-0.5">
                  {m.year} · {m.genres[0]}
                </p>
              </div>
              <span className="flex items-center gap-0.5 text-accent-600 text-xs font-label font-semibold shrink-0">
                <i className="ri-star-fill"></i>
                {m.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
      <Link
        to="/category?sort=popular"
        className="mt-4 flex items-center justify-center gap-1 h-10 rounded-md border border-background-200 text-sm font-label text-secondary-600 hover:border-accent-300 hover:text-accent-700 transition-colors cursor-pointer"
      >
        查看完整榜单
        <i className="ri-arrow-right-line"></i>
      </Link>
    </aside>
  );
}